import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";

import { FeedbackRoute } from "../../containers/FeedbackRoute";

type FeedbackSearch = {
    id?: string;
};

export const Route = createFileRoute("/_layout-nosidebar/feedback")({
    component: Feedback,
    validateSearch: (search: FeedbackSearch & SearchSchemaInput): FeedbackSearch => ({
        id: search.id,
    }),
});

function Feedback() {
    return <FeedbackRoute />;
}
